import { observer } from 'mobx-react'
import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { IJobBase } from '@/types'
import { getSignInPath, useStores } from '@/utils'
import { Button2 } from '@/componentsV2/atoms/Button2'
import { BookarkJobIconButton } from '@/componentsV2/molecules/BookarkJobIconButton'
import styles from './index.module.scss'

type Props = {
  job: IJobBase
}

export const JobSaveAndApplyGroup: FC<Props> = observer(({ job }) => {
  const { t } = useTranslation(['jobs-[job_slug]', 'jobs'])
  const { viewer, ui } = useStores()
  const router = useRouter()

  const openJobApplicationModal = () => {
    if (viewer.isSignedIn) {
      ui.toggleJobApplicationModal()
    } else {
      const path = getSignInPath(router.asPath)
      router.push(path)
    }
  }

  const isCompanyMember = viewer.viewer?.isCompanyMember(job?.company.slug)

  return (
    <div className={styles.container}>
      {/* TODO: 保存ボタン調整 */}
      <BookarkJobIconButton job={job} />
      <Button2
        hierarchy='primary'
        componentType='button'
        buttonType='button'
        size='sm'
        disabled={isCompanyMember}
        onClick={openJobApplicationModal}
      >
        {t('応募する')}
      </Button2>
    </div>
  )
})
